import { Component, OnInit, ViewChild, Output, EventEmitter } from "@angular/core";
import { RoleService } from "../shared/role.service";
import { RoleStateService } from "../shared/role-state.service";
import { ToastrService } from "ngx-toastr";
import { ListRolesComponent } from "../listroles/listroles.component";

@Component({
  selector: "app-addrole",
  templateUrl: "./addrole.component.html",
  styleUrls: ["./addrole.component.css"],
})
export class AddRoleComponent implements OnInit {
  @ViewChild(ListRolesComponent) roleModal: ListRolesComponent;
  @Output() roleAdded = new EventEmitter<any>();
  role: any = {};
  isProcessing = false;

  constructor(
    private _addRoleService: RoleService,
    private toastr: ToastrService,
    private roleStateService: RoleStateService
  ) {}

  ngOnInit() {}

  sendNewRole(role) {
    return this._addRoleService.createNewRole(role);
  }
  createNewRole(newRole) {
    this.sendNewRole(newRole).subscribe(
      (result: any) => {
        this.toastr.success("Role added successfully", "Success!");

        this.roleStateService.refreshRoles().subscribe();

        this.closeModalRole();
        this.roleAdded.emit(result);
      },
      (error) => {
        this.toastr.warning(error, "Alert!", {
          closeButton: true,
          enableHtml: true,
        });
        console.dir(error);
        this.isProcessing = false;
      }
    );
  }

  closeModalRole() {
    const closeModal = document.getElementsByClassName("p-dialog-header-close")[0] as HTMLElement;
    closeModal.click();
  }
}
